import { arenaCommunityService } from "./arena-community.service";
import { arenaMatchService } from "./arena-match.service";
import { arenaOverviewService } from "./arena-overview.service";
import { arenaResultsService } from "./arena-results.service";

export { matchMediaService } from "./match-media.service";

export const arenaService = {
  ...arenaOverviewService,
  ...arenaCommunityService,
  ...arenaMatchService,
  ...arenaResultsService,
};
